// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__oILkj","label":"CheckBox_label__NH4S8","input":"CheckBox_input__00A1T"};